export default "__VITE_ASSET__ByVc$KsT__"